import { mapGetters } from 'vuex'
import { getAction, defaultSelectValue, compositeTitle } from '../utils/utils'
import tournaments from '@/router/tournaments'

let localWatchers = []

export default {
  data () {
    return {
      isLoading: true
    }
  },
  watch: {
    isLoading (newVal, oldVal) {
      this.$nextTick(() => {
        this.$bus.$emit('filters-inited')
      })
    }
  },
  methods: {
    async initFilters () {
      if (localWatchers.length) {
        localWatchers.forEach(({ unwatch, fetchFunc }) => {
          fetchFunc()
          unwatch()
        })
      }

      this.filters = {
        checks: {},
        selects: {}
      }

      await this.initSelects()
      await this.initChecks()

      this.isLoading = false
    },
    initChecks () {
      const { checks } = this.filtersScheme

      if (!checks) {
        return
      }

      checks.forEach(name => {
        this.$set(this.filters.checks, name, this.setCheckFromQuery(name))
      })
    },
    setCheckFromQuery (name) {
      const { query } = this.$route

      if (query[name]) {
        return query[name]
      }

      return ''
    },
    async initSelects () {
      const { autonomous, dependent } = this.filtersScheme.selects

      await this.setAutonomusSelects(autonomous)

      await this.setDependentSelects(dependent)
    },
    async setAutonomusSelects (filters) {
      for (let item in filters) {
        const { name, storeName } = filters[item]

        let moduleStore = storeName.split('/')[0]

        await this.fetchSelectsData(moduleStore)

        this.setSelectFromQuery(name, moduleStore)
          .then(res => {
            this.$set(this.filters.selects, name, res)
          })
      }
    },
    async setDependentSelects (filters) {
      for (let item in filters) {
        const { name, storeName, dependentTo, fetchFunc } = filters[item]
        const dependencyId = this.filters.selects[dependentTo].id
        // const dependencyId = 1

        if (dependencyId) {
          await this[fetchFunc](dependencyId)
        }

        this.setSelectFromQuery(name, storeName)
          .then(res => {
            this.$set(this.filters.selects, name, res)

            const watcher = this.$watch(`filters.selects.${dependentTo}`, (newVal, oldVal) => {
              if (newVal.id === oldVal.id) {
                return
              }

              if (name === 'tournament') {
                this.$set(this.filters.selects, name, [])
              } else {
                this.$set(this.filters.selects, name, defaultSelectValue())
              }

              this.toggleQuery({
                name,
                value: '',
                isMultiple: name === 'tournament'
              })

              this[fetchFunc](newVal.id)
            })

            localWatchers.push({ unwatch: watcher, fetchFunc: this[fetchFunc] })
          })
      }
    },
    async fetchSelectsData (storeName) {
      await this[getAction(storeName)]()
    },
    async setSelectFromQuery (name, storeName) {
      const { userLang } = this
      const { query } = this.$route
      const value = query[name]

      if (name === 'tournament') {
        if (value) {
          const data = Array.isArray(value) ? value : [value]

          const items = []

          for (let id of data) {
            const v = await this.$api.getTournamentById(parseInt(id))
            items.push(v)
          }

          return items.map(el => ({
            id: el.id,
            title: el['ctitles']
              ? compositeTitle(el['ctitles'], userLang)
              : el.title
          }))
        } else return []
      }

      if (value) {
        let filteredItem = this[storeName].data.filter(item => item.id === parseInt(value))[0]

        if (filteredItem) {
          return {
            id: filteredItem.id,
            title: filteredItem['ctitles']
              ? compositeTitle(filteredItem['ctitles'], userLang)
              : filteredItem.title
          }
        }

        try {
          filteredItem = storeName !== 'tournaments' ? await this[getAction(storeName)]({
            search: {
              self_id: value
            }
          }) : await this.$api.getTournamentById(value)

          const data = storeName !== 'tournaments' ? filteredItem[0] : filteredItem

          if (data) {
            return {
              id: data.id,
              title: data['ctitles']
                ? compositeTitle(data['ctitles'], userLang)
                : data.title
            }
          }
        } catch (e) {
          console.error(e)
        }
      }

      return defaultSelectValue()
    },
    // TODO при добавлении новых зависимых фильтров убрать в компоненты
    async getTournaments (id) {
      this.tournaments = {
        data: [],
        count: null,
        url: ''
      }

      if (id) {
        const params = {
          filter: {
            sport_id: id
          },
          with_attributes: ['ctitles', 'rights']
        }

        try {
          const { data, recordsFiltered: recordsTotal } = await this.$api.getTournaments(params)
          this.$store.commit('tournaments/SET_LIST', { data, recordsTotal, sportId: id })
          this.$store.commit('tournaments/LIST_UPDATE_STATUS', { value: false })

          this.tournaments = {
            data,
            count: recordsTotal,
            url: 'tournaments',
            storeName: 'tournaments'
          }
        } catch (e) {
          console.error(e)
        }
      }
    }
  },
  computed: {
    ...mapGetters(['userLang'])
  }
}
